import { IAjaxConfig } from '../libraries';
/**
 *  活动内容 API 地址
 *  测试环境API链接结构
格式：https://tst-bpcentral.lenovo.com.cn/api/{app-name}/{service-name}/{service-uri}
示例：https://tst-bpcentral.lenovo.com.cn/api/bpportal-mall/bpportal-mall-order-sit/managerorder/order/kuaiDi100LogisticsInformation/wrtt
 */
export class EnumApiContent {
  /**
   * @des 直播活动  推广记录器
   */
  readonly content_live_record: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bff-content/public/v1/promotion/record',
    method: 'post',
  };
}
